import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { loginPath } from '../../lib/login-redirect';
import type { RootState } from '../../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps): React.JSX.Element => {
  const currentUser = useSelector((state: RootState) => state.auth.currentUser);
  const location = useLocation();

  if (!currentUser) {
    // Sign-in returns here afterwards.
    return <Navigate to={loginPath(`${location.pathname}${location.search}${location.hash}`)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
